import type {
  Block,
  CalloutData,
} from "../../../../models/ManualAuthoring";

import { useManualAuthoringStore } from "../../../../store/manualAuthoringStore";
import StructuredInlineTextEditor from "../editor/StructuredInlineTextEditor";
import "./note.css";

export default function NoteEdit({
  block,
  onDone,
}: {
  block: Block;
  onDone: () => void;
}) {
  const updateBlock = useManualAuthoringStore((s) => s.updateBlock);
  const data = block.data as CalloutData;

  return (
    <div className="pdf-block pdf-note pdf-note--editing">
      <div className="pdf-note__line">
        <span className="pdf-note__label">NOTE:</span>
        <div className="pdf-note__content">
          <StructuredInlineTextEditor
            textParts={data.textParts || []}
            onChange={(newParts) => updateBlock(block.id, { textParts: newParts })}
            onDone={onDone}
          />
        </div>
      </div>
    </div>
  );
}
